import { defineStore, acceptHMRUpdate } from 'pinia';
import { SOCKET_CONNECTION_STATUSES } from '@/comments/comments.utils';

interface PendoCollaborationState {
    drawerOpen: boolean;
    connectionStatus: string;
}

export function getInitialState (): PendoCollaborationState {
    return {
        drawerOpen: false,
        connectionStatus: SOCKET_CONNECTION_STATUSES.PENDING,
    };
}

export const usePendoCollaborationStore = defineStore('pendoCollaboration', {
    state: getInitialState,
    getters: {
        getConnectionStatus: (state): string => state.connectionStatus,
    },
    actions: {
        setDrawerOpen ({ drawerOpen }: { drawerOpen: boolean }) {
            this.drawerOpen = drawerOpen;
        },
        setConnectionStatus ({ status }: { status: string }) {
            this.connectionStatus = status;
        },
        toggleDrawer () {
            this.drawerOpen = !this.drawerOpen;
        },
        teardown () {
            Object.assign(this, getInitialState());
        },
    },
});

if (module.hot) {
    module.hot.accept(acceptHMRUpdate(usePendoCollaborationStore, module.hot));
}
